import clsx from "clsx";
import { Fragment } from "react";

interface HighlightedTextProps {
  children: string;
  highlightClassname?: string;
}

export default function HighlightedText({
  children,
  highlightClassname,
}: HighlightedTextProps) {
  const match = children.match(/<em>(.*?)<\/em>/);

  if (match) {
    return (
      <Fragment>
        {children.slice(0, match.index)}
        <span
          className={clsx("bg-orange-100 text-orange-500", highlightClassname)}
        >
          {match[1]}
        </span>
        {children.slice(match.index + match[0].length)}
      </Fragment>
    );
  }
  return children;
}
